import { useStoredBrand } from "./brand-cache";
import { brandingQueryKey, publicBrandingQueryKey } from "@/api";
import type { Branding, PublicBranding } from "@/contracts";
import { resolvePublicTenantHost } from "@/lib/api-base-url";
import { queryClient } from "@/lib/query-client";

type Brand = Pick<Branding, "logo" | "images" | "settings" | "texts" | "colors">;

export function useCachedBrand(): Brand | undefined {
  const pathname = globalThis.location?.pathname ?? "/";
  const publicOnly = [
    "/auth",
    "/reset-password",
    "/join/",
    "/buy/",
    "/public/",
    "/privacidade",
    "/termos",
    "/certificado/",
  ].some((path) => pathname.startsWith(path));
  const cached = useStoredBrand(publicOnly);
  return (
    cached ??
    (publicOnly ? undefined : queryClient.getQueryData<Branding>(brandingQueryKey)) ??
    queryClient.getQueryData<PublicBranding>(publicBrandingQueryKey(resolvePublicTenantHost()))
  );
}
